import React from 'react';
import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';

const WidgetStore = (props) => {
  //console.log(props);

  const { tveeImgUrl } = props;
  const cardData = props.childProps.payload.list;
  const preText = props.childProps.state.prevMessage;

  const _prev = () => {
    props.childProps.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };

  const _go = (url) => {
    //console.log(url);
    const { history } = props;
    history.push(url);
  };
  return (
    <>
      <div className="card">
        <img src={cardData.imageUrl} alt={cardData.title} />
        <div className="card-content">
          <h3>{cardData.title}</h3>
          <p>주소: {cardData.address}</p>
          <p>전호번호: {cardData.tel}</p>
          <p>이메일: {cardData.email}</p>
          <p>영업시간: {cardData.time}</p>
          <div className="btn" onClick={() => _go(cardData.buttonUrl)}>
            바로가기
          </div>
        </div>
      </div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
      {/* <div onClick={_prev} className="prev">
        이전 단계로 이동
      </div> */}
    </>
  );
};
export default shopContext(withRouter(WidgetStore));
